import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import ScenarioQuestionformat from "../../../../Student/Reusablecomponents/ScenarioQuestionformat";
import { useLocation } from "react-router-dom";
const TranslateEditor = (props) => {
  const location = useLocation();
  const [EdiText, SetEdiText] = useState(props.EditData?.value || "");
  const inputRef = useRef(null);

  const [suggestions, setSuggestions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [wordIndex, setWordIndex] = useState(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  // Apply selected suggestion
  const applySuggestion = (index) => {
    if (wordIndex === null) return;

    const words = EdiText.split(" ");
    words[wordIndex] = suggestions[index];

    const updatedText = words.join(" ");
    SetEdiText(updatedText);
    setSuggestions([]);

    const newCursorPos =
      words.slice(0, wordIndex + 1).join(" ").length +
      (wordIndex < words.length - 1 ? 1 : 0);

    setTimeout(() => {
      inputRef.current.setSelectionRange(newCursorPos, newCursorPos);
    }, 0);
  };

  // Handle keyboard navigation in suggestions
  const handleKeyDown = (event) => {
    if (event.key === "ArrowDown") {
      setSelectedIndex((prevIndex) => (prevIndex + 1) % suggestions.length);
    } else if (event.key === "ArrowUp") {
      setSelectedIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : suggestions.length - 1
      );
    } else if (event.key === "Enter" && suggestions.length > 0) {
      applySuggestion(selectedIndex);
      event.preventDefault();
    }
  };

  // Handle input change and fetch suggestions
  const handleChange = async (event) => {
    const inputText = event.target.value;
    SetEdiText(inputText);

    const cursorPos = event.target.selectionStart;
    const words = inputText.split(" ");

    let charCount = 0;
    let editingIndex = null;
    for (let i = 0; i < words.length; i++) {
      charCount += words[i].length + 1;
      if (cursorPos <= charCount) {
        editingIndex = i;
        break;
      }
    }

    setWordIndex(editingIndex);

    if (editingIndex !== null) {
      const lastWord = words[editingIndex].toLowerCase();
      if (lastWord.length > 0) {
        try {
          const response = await axios.get(
            `https://varnam.subinsb.com/tl/hi/${lastWord}`
          );
          setSuggestions(response.data.result || []);
          setSelectedIndex(0);
          // updateCursorPosition(event);
        } catch (error) {
          console.error("Error fetching suggestions:", error);
          setSuggestions([]);
        }
      } else {
        setSuggestions([]);
      }
    }
  };

  // Update position of suggestions list
  const updateCursorPosition = (event) => {
    if (!inputRef.current) return;

    const { selectionStart } = inputRef.current;
    const rect = inputRef.current.getBoundingClientRect();
    // const lineHeight = 24;

    const textBeforeCursor = inputRef.current.value.substring(
      0,
      selectionStart
    );
    const lines = textBeforeCursor.split("\n");
    const row = lines.length;
    const col = lines[lines.length - 1].length;
    const cursorX = rect.left + col * 5;
    const cursorY = rect.top + row * 24;
    // const cursorX = rect.left +col  * 8;
    // const cursorY = rect.top + row * 24;

    setPosition({ top: cursorY, left: cursorX });
  };

  // Save Edited Data
  const SaveEdit = () => {
    if (props.EditData.opendata) {
      props.EditData.Store({
        ...props.EditData.opendata,
        [props.EditData.AData]: EdiText,
      });
    } else {
      props.EditData.Store(EdiText);
    }
    props.close(false);
  };

  return (
    <>
      <div className="dflex JSBetween alignitems">
        <div className="SubHeading">{props.EditData.AData}</div>
        <button className="Buttons" onClick={() => props.close(false)}>
          Close
        </button>
      </div>
      <div className="container-fluid">
        Edit text
        <Row>
          <Col>
            <textarea
              ref={inputRef}
              className="w-100"
              value={EdiText}
              rows="7"
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              // onClick={updateCursorPosition}
            />
          </Col>
          {suggestions.length > 0 && (
            <ul
              style={{
                backgroundColor: "white",
                border: "1px solid gray",
                listStyle: "none",
                padding: 0,
                marginBottom: "5px",
                textAlign: "left",
                cursor: "pointer",
                overflowY: "auto",
                width: "300px",
              }}
            >
              {suggestions.map((suggestion, index) => (
                <li
                  key={index}
                  onClick={() => applySuggestion(index)}
                  style={{
                    padding: "10px",
                    backgroundColor: selectedIndex === index ? "#ddd" : "white",
                  }}
                >
                  {index + 1}: {suggestion}
                </li>
              ))}
            </ul>
          )}
        </Row>
        <button
          className="Buttons mt-2"
          style={{ float: "right" }}
          onClick={SaveEdit}
        >
          Save
        </button>
      </div>
    </>
  );
};

export default TranslateEditor;
